import React from 'react';
import { useTranslation } from 'react-i18next';
import IframeEmbed from '../../../components/patients/IframeEmbed';
import { apiZedocGetSentimentAnalysisToken } from '../../../common/api/zedoc';
import PageBar from '../../../components/Layout/PageBar';

const SentimentAnalysis = () => {
  const { t } = useTranslation();

  return (
    // Fills the flex column MasterLayout provides so the embed gets whatever
    // height is left below the PageBar.
    <div className="-mx-4 -my-6 flex flex-col flex-1 min-h-0">
      <PageBar title={t('sentimentAnalysis')} isNewPresentation />
      <IframeEmbed
        apiSpec={apiZedocGetSentimentAnalysisToken}
        params={{}}
        title={t('sentimentAnalysis')}
        toolName="sentiment analysis tool"
        fillHeight
      />
    </div>
  );
};

export default SentimentAnalysis;
